// src/context/IconSettingsContext.js
import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import api from '../api/axiosConfig';
import { useAuth } from './AuthContext';

// Custom icon overrides for navbar items and hub tiles — a single global
// map of { key: '/icons/custom/<file>' }, fetched once and shared by every
// <SectionIcon> in the app. Sections with no entry just render their
// hardcoded default emoji.
const IconSettingsContext = createContext({ icons: {}, refresh: () => {} });

export const useIconSettings = () => useContext(IconSettingsContext);

export const IconSettingsProvider = ({ children }) => {
  const { user } = useAuth();
  const [icons, setIcons] = useState({});

  const refresh = useCallback(() => {
    api.get('settings/icons/')
      .then(r => setIcons(r.data || {}))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (user) refresh();
  }, [user, refresh]);

  return (
    <IconSettingsContext.Provider value={{ icons, refresh }}>
      {children}
    </IconSettingsContext.Provider>
  );
};
